var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slideshow"},[_c('el-carousel',{attrs:{"arrow":"always"}},_vm._l((_vm.slideshowList),function(item){return _c('el-carousel-item',{key:item.id},[_c('el-image',{attrs:{"fit":_vm.fits[0],"src":item.imgPath},on:{"click":function($event){return _vm.handleJump(item.jumpPath)}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }